import moment from 'moment';

import {fetch} from '~/lib/fetch';
import config from '~/configuration';

const reduce_overview = (acc, request) => {
  const date = moment(request.datetime).format('YYYY-MM');
  if (!acc[date]) {
    acc[date] = {};
  }

  const day = moment(request.datetime).format('YYYY-MM-DD');
  if (!acc[date][day]) {
    acc[date][day] = [];
  }

  acc[date][day].push(request);
  return acc;
};

const transform_to_items = (data) => {
  const items = [];
  Object.keys(data)
    .sort((a, b) => b.localeCompare(a))
    .forEach((date) => {
      items.push({
        type: 'month',
        value: date,
      });

      Object.keys(data[date])
        .sort((a, b) => b.localeCompare(a))
        .forEach((day) => {
          const requests = data[date][day];
          requests.forEach((request, index) => {
            items.push({
              type: 'request',
              value: {
                request,
                index,
              },
            });
          });
        });
    });

  return items;
};

const prefix = async (prefix) => {
  const response = await fetch(config.api, {
    method: 'POST',
    body: JSON.stringify({
      query: `
        query Query($prefix: String!) {
            requests: search(
                prefix: $prefix
            ) {
              rob_request_id
              snapshot_id
              service_request_id
              parent_id
              dealer {
                name
              }
              datetime
              license
              type
              status
              replacement {
                type
              }
              car {
                name
              }
              icons
            }
          }    
        `,
      variables: {
        prefix,
      },
    }),
  });

  const {requests} = await response.json();

  return transform_to_items(requests.reduce(reduce_overview, {}));
};

const filter = async (request_type, status) => {
  const response = await fetch(config.api, {
    method: 'POST',
    body: JSON.stringify({
      query: `
        query Query($request_type: String!, $status: String!) {
            requests: filter(
              request_type: $request_type
              status: $status
            ) {
              rob_request_id
              snapshot_id
              service_request_id
              parent_id
              dealer {
                name
              }
              datetime
              license
              type
              status
              replacement {
                type
              }
              car {
                name
              }
              icons
            }
          }    
        `,
      variables: {
        request_type,
        status,
      },
    }),
  });

  const {requests} = await response.json();

  return transform_to_items(requests.reduce(reduce_overview, {}));
};

export default {
  prefix,
  filter,
};
